import { AdminContainer } from "../container";
import React from "react";

export function MiscButtonScreen({ children }: { children: React.ReactNode }) {
    return <AdminContainer>{children}</AdminContainer>;
}
